/**
 * @file dialog-utils.js
 * @description Utilitários do sistema de diálogos (CRA)
 */

import React from "react"
import { AlertCircle, AlertTriangle, CheckCircle, Info } from "lucide-react"
import { cn } from "../../../../lib/utils.js"

/**
 * Retorna o ícone apropriado baseado no tipo do dialog
 * @param {string} type - Tipo do dialog
 * @returns {React.ReactElement} Componente do ícone
 */
export function getDialogIcon(type = "info") {
  const iconClass = "h-16 w-16"
  switch (type) {
    case "success":
      return React.createElement(CheckCircle, {
        className: cn(iconClass, "text-green-500"),
      })
    case "error":
      return React.createElement(AlertCircle, {
        className: cn(iconClass, "text-red-500"),
      })
    case "warning":
      return React.createElement(AlertTriangle, {
        className: cn(iconClass, "text-yellow-500"),
      })
    case "confirm":
      return React.createElement(AlertCircle, {
        className: cn(iconClass, "text-blue-500"),
      })
    default:
      return React.createElement(Info, {
        className: cn(iconClass, "text-blue-500"),
      })
  }
}

/**
 * Retorna as cores apropriadas baseadas no tipo do dialog
 * @param {string} type - Tipo do dialog
 * @returns {Object} Objeto com as cores
 */
export function getDialogColors(type = "info") {
  switch (type) {
    case "success":
      return {
        confirmButton: "bg-green-500 hover:bg-green-600 text-white",
        border: "border-green-200",
      }
    case "error":
      return {
        confirmButton: "bg-red-500 hover:bg-red-600 text-white",
        border: "border-red-200",
      }
    case "warning":
      return {
        confirmButton: "bg-yellow-500 hover:bg-yellow-600 text-white",
        border: "border-yellow-200",
      }
    case "confirm":
      return {
        confirmButton: "bg-blue-500 hover:bg-blue-600 text-white",
        border: "border-blue-200",
      }
    default:
      return {
        confirmButton: "bg-blue-500 hover:bg-blue-600 text-white",
        border: "border-blue-200",
      }
  }
}
